
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIcon as ObiIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon.js';
 
 
 

 
 export const ObiIcon = createComponent({
   react: React,
   tagName: 'obi-icon',
   elementClass: ObiIconElement,
   events: {
     
   }
  });
 
 